import styles from './App.module.css';
import Home from './components/Home';
import CommissionPage from './components/CommissionPage';
import ProfilePage from './components/ProfilePage';
import InvalidPage from './components/InvalidPage';
import {BrowserRouter as Router, Route, Switch} from 'react-router-dom';

function App() {
  return (
    <Router>
      <div className={styles.mainContainer}>
        {/* navbar here */}
        <div className='content'>
          <Switch>
            <Route exact path='/'>
              <Home />
            </Route>
            <Route exact path="/:userId" component={ProfilePage}/>
            <Route exact path="/astro-owl/commission/:paramId" component={CommissionPage}/>
            <Route path='/'>
              <InvalidPage />
            </Route>
          </Switch>
        </div>
      </div>
    </Router>
  );
}

export default App;
